import { mdiBookOutline } from '@mdi/js';
import Icon from '@mdi/react';

const NoCompletedCourses = () => {
    return (
        <div
            className='alert alert-info mb-0'
            role='alert'
        >
            <h5 className='alert-heading'>
                <Icon
                    path={mdiBookOutline}
                    className='mdi mr-1'
                />
                Inga genomförda kurser
            </h5>
            <p>
                Du har inte genomfört någon kurs.{' '}
                <a
                    href='https://www.transport.se/medlemskapet/utbildning/'
                    className='link-external'
                    target='_blank'
                    rel='noreferrer'
                >
                    Se vårt kursutbud
                </a>
                .
            </p>
        </div>
    );
};

export default NoCompletedCourses;
